const FLAG = 'rr_comment_access_reconnect';
function clearCommentReportsAfterReconnect(storage, connected) {
  try {
    if (storage?.getItem(FLAG) !== '1') return;
    storage.removeItem(FLAG);
    if (!connected) return;
    for (const key of Object.keys(storage)) {
      if (key.startsWith('rr-analytics-v3:') && key.includes(':/analytics/comments/')) storage.removeItem(key);
    }
  } catch { /* A failed storage cleanup does not block account access. */ }
}
module.exports = { clearCommentReportsAfterReconnect };
